export const ENERGY_CARD_QR_PREFIX = '220km-energy-card:';
/** Matches backend EnergyCardService.ENERGY_CARD_DELIMITER */
export const ENERGY_CARD_INVOICE_DELIMITER = '___energyCard___';

export function parseEnergyCardQrPayload(raw) {
  if (!raw || typeof raw !== 'string') {
    return null;
  }
  const value = raw.trim();
  if (!value.startsWith(ENERGY_CARD_QR_PREFIX)) {
    return null;
  }
  const token = value.slice(ENERGY_CARD_QR_PREFIX.length).trim();
  return token || null;
}

export function isEnergyCardInvoiceId(invoiceId) {
  return typeof invoiceId === 'string' && invoiceId.includes(ENERGY_CARD_INVOICE_DELIMITER);
}

function energyCardCoversPort(card, stationNumber) {
  const port = String(stationNumber ?? '').trim();
  if (!port) {
    return false;
  }
  return (card?.stationNumbers || []).some(number => String(number).trim() === port);
}

/**
 * True when this job is billed to an energy card.
 * hasInProgress on some other port must not relabel a paid session:
 * that fallback applies only before an invoice exists, and only for a card
 * activated on the current port.
 */
export function isEnergyCardChargingSession({ invoiceId, showStop, stationNumber, energyCards } = {}) {
  if (isEnergyCardInvoiceId(invoiceId)) {
    return true;
  }
  if (invoiceId) {
    return false;
  }
  if (!showStop) {
    return false;
  }
  return (energyCards || []).some(card => card?.hasInProgress && energyCardCoversPort(card, stationNumber));
}

/** Energy-card client UUID embedded in invoiceId before the delimiter. */
export function getEnergyCardClientIdFromInvoice(invoiceId) {
  if (!isEnergyCardInvoiceId(invoiceId)) {
    return null;
  }
  const id = invoiceId.split(ENERGY_CARD_INVOICE_DELIMITER)[0]?.trim();
  return id || null;
}
